module.exports = __webpack_public_path__ + "img/jingdian1.6b2b6c5a.png";